var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderResults(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "85px",
    height: "85px",
    viewBox: "0 0 85 85",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Report_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Report_icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder_blue",
    transform: "translate(2.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5305615,9.04598048 C38.0398647,9.04598048 31.7796524,0.0455008237 25.8404337,0.15725108 C16.7001562,0.329231335 6.90193219,0.581562734 6.90193219,0.581562734 C4.69810179,0.636497733 2.91154426,2.47036441 2.91154426,4.68937404 L2.91154426,58.1248451 C2.91154426,60.3385916 4.70812954,62.1331878 6.91475226,62.1331878 L74.6084871,62.1331878 C76.8193978,62.1331878 78.6116951,60.3460025 78.6116951,58.1331781 L78.6116951,13.7737027 C78.6116951,11.5645583 76.8134219,9.72424646 74.6213325,9.66553285 C74.6213325,9.66553285 52.7530098,9.04598048 42.5305615,9.04598048 Z",
    id: "back",
    stroke: "#AFC0D3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.666634,18.1386421 C30.3878339,18.1386421 4.00049253,18.77382 4.00049253,18.77382 C1.79108151,18.8249255 0,20.6535399 0,22.8663643 L0,67.2258397 C0,69.4349841 1.7977397,71.2258494 4.00107193,71.2258494 L77.5221674,71.2258494 C79.7318984,71.2258494 81.5232393,69.4386642 81.5232393,67.2258397 L81.5232393,22.8663643 C81.5232393,20.6572199 79.7423101,18.8208329 77.5248995,18.7655516 C77.5248995,18.7655516 53.6754245,18.1386421 42.666634,18.1386421 Z",
    id: "front",
    stroke: "#AFC0D3",
    fill: "#CDF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0091885,19.462666 C29.7303885,19.462666 3.34304705,20.0978439 3.34304705,20.0978439 C1.13363604,20.1489493 1.12827329,20.2887507 3.33751267,20.410454 L72.1634233,24.2019583 C74.3697778,24.3235027 76.3329123,26.2064094 76.5476137,28.4014828 L80.4765616,68.5704243 C80.6915286,70.7682133 80.8657938,70.762688 80.8657938,68.5498636 L80.8657938,24.1903881 C80.8657938,21.9812438 79.0848646,20.1448568 76.8674541,20.0895754 C76.8674541,20.0895754 53.017979,19.462666 42.0091885,19.462666 Z",
    id: "gloss",
    fill: "#FFFFFF",
    opacity: 0.626340951,
    transform: "translate(40.874364, 45.230672) scale(1, -1) translate(-40.874364, -45.230672) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "label",
    stroke: "#AFC0D3",
    fill: "#FFFFFF",
    x: 7.86235523,
    y: 26.3503365,
    width: 24.2993179,
    height: 4.52331542,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "label",
    fill: "#ECF1F7",
    x: 8.20562234,
    y: 5.60937267,
    width: 15.1801124,
    height: 4.67994207,
    rx: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    stroke: "#AFC0D3",
    fill: "#FFFFFF",
    x: 66.5,
    y: 32.5,
    width: 3,
    height: 16,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    stroke: "#AFC0D3",
    fill: "#FFFFFF",
    x: 72.5,
    y: 39.5,
    width: 3,
    height: 9,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    stroke: "#AFC0D3",
    fill: "#FFFFFF",
    x: 60.5,
    y: 29.5,
    width: 3,
    height: 19,
    rx: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderResults);
export default __webpack_public_path__ + "static/media/folderResults.c4c288f269b1cc38f7959032750577a6.svg";
export { ForwardRef as ReactComponent };